import React from "react";

export const Divider = () => {
    return (
        <div style={{ width: "100%", height: "5px", backgroundColor: "#37003C" }}>
        </div>
    );
}